var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnactiveUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.4287 5.41973C12.4287 7.86122 10.4491 9.83946 8.00893 9.83946C5.56744 9.83946 3.58789 7.86122 3.58789 5.41973C3.58789 2.97824 5.56744 1 8.00893 1C10.4491 1 12.4287 2.97824 12.4287 5.41973Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "square"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.04289 13.0684C11.2992 13.0601 14.068 14.5552 15.0858 17.7737C13.0344 19.0243 10.6198 19.5059 8.04289 19.4996C5.46601 19.5059 3.05137 19.0243 1 17.7737C2.0189 14.5517 4.78303 13.0601 8.04289 13.0684Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "square"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15 9L20 4",
    stroke: "white",
    strokeWidth: 1.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20 9L15 4",
    stroke: "white",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnactiveUser);
export default __webpack_public_path__ + "static/media/unactiveUser.aad18e3a3fd238bad642b5d1771c3212.svg";
export { ForwardRef as ReactComponent };